export default "/_next/static/images/621b45d839a0f18bcb7d0ecde88dbdaf.svg";